import React from 'react';

export default function SVGFilters() {
  return (
    <svg aria-hidden="true" height="0" width="0">
      <defs>
        <filter id="noise-filter">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.75"
            numOctaves="2"
            stitchTiles="stitch"
          />
        </filter>
      </defs>
    </svg>
  );
}
